module.exports = __webpack_public_path__ + "Banner_Exercise_repeatable-423f527055e114e132ac05a098f58edb.svg";